/**
 * Agent 档位名称 → i18n key 映射
 *
 * 后端返回的 name 为 "PRO 1" ~ "PRO 5"，
 * 前端展示需要根据语言翻译为 探索版 / 进阶版 / 专业版 / 旗舰版 / 创世版。
 */

import { CCC_AIF_ADDRESS, CCC_FUSD_ADDRESS, USDT_ADDRESS } from "./env";

/** 非 ERC20：AIFx 在余额/划转接口中的 coinContract（与后端约定） */
export const INTEGRAL_COIN_CONTRACT = "FotPoint" as const;
/** 从其它页面跳转到个人页后自动打开充值弹窗的 sessionStorage key */
export const PROFILE_OPEN_DEPOSIT_SESSION_KEY = "profile:openDepositModal";

const AGENT_TIER_MAP: Record<string, string> = {
  "PRO 1": "agentTier.explorer",
  "PRO 2": "agentTier.advanced",
  "PRO 3": "agentTier.professional",
  "PRO 4": "agentTier.flagship",
  "PRO 5": "agentTier.genesis",
};

/**
 * 根据 agent.name 获取对应的 i18n key。
 * 找不到时回退为原始 name。
 */
export function getAgentTierKey(name: string): string {
  return AGENT_TIER_MAP[name] ?? name;
}

/** 风险偏好 ID → react-i18next 完整 key（命名空间 aiTradingPage） */
const RISK_ID_I18N_FULL_KEY: Record<number, string> = {
  1: "aiTradingPage.riskProfile1",
  2: "aiTradingPage.riskProfile2",
  3: "aiTradingPage.riskProfile3",
  4: "aiTradingPage.riskProfile4",
  5: "aiTradingPage.riskProfile5",
};

/**
 * 根据 riskId 获取风险偏好文案的 i18n 完整 key，供 `t(key)` / `t(key, { id })` 使用。
 * 0 或缺省 → riskProfileNone；未知 ID → riskProfileUnknown（需传入 `id` 插值）。
 */
export function getRiskProfileI18nKey(riskId: number): string {
  if (!riskId) return "aiTradingPage.riskProfileNone";
  return RISK_ID_I18N_FULL_KEY[riskId] ?? "aiTradingPage.riskProfileUnknown";
}

export function getTokenName(address: string): string {
  switch (address) {
    case USDT_ADDRESS:
      return "USDT";
    case CCC_FUSD_ADDRESS:
      return "FUSD";
    case CCC_AIF_ADDRESS:
      return "TSK";
    case INTEGRAL_COIN_CONTRACT:
      return "TSKx";
    default:
      return "";
  }
}
